<template>
    <slot :is-menu-open="isMenuOpen" :toggle-menu="toggleMenu"></slot>
</template>

<script>
export default {
    data() {
        return {
            isMenuOpen: window.innerWidth > 768,
        };
    },

    mounted() {
        window.addEventListener('resize', this.onResize);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
    },

    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },

        onResize() {
            this.isMenuOpen = window.innerWidth > 768;
        },
    },
};
</script>
